<div class="payer-compliance-list" style="padding: 24px 16px; max-width: 1200px; margin: 0 auto;">

  <!-- ── Header + contador de pendientes ── -->
  <div class="header" style="display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; margin-bottom:16px;">
    <h2 style="margin:0; font-size:1.3rem; font-weight:800; color:#1C593D;">Pagadores — Compliance</h2>

    <div style="display:inline-flex; align-items:center; gap:10px; background:#fff7ed; border:1px solid #fed7aa; border-radius:12px; padding:8px 16px;">
      <mat-icon style="color:#ea580c;">pending_actions</mat-icon>
      <span style="font-size:1.4rem; font-weight:800; color:#ea580c; line-height:1;">{{ pendientesCount }}</span>
      <span style="font-size:0.8rem; color:#9a3412; font-weight:600;">por aprobar</span>
    </div>
  </div>

  <!-- ── Filtros por estado ── -->
  <div class="toolbar" style="display:flex; align-items:center; gap:8px; flex-wrap:wrap; margin-bottom:16px;">
    <button *ngFor="let e of estados" type="button" (click)="seleccionar(e.id)"
      [style.background]="estadoSeleccionado === e.id ? '#1C593D' : 'white'"
      [style.color]="estadoSeleccionado === e.id ? 'white' : '#374151'"
      [style.border]="estadoSeleccionado === e.id ? '1px solid #1C593D' : '1px solid #e5e7eb'"
      style="display:inline-flex; align-items:center; gap:6px; padding:7px 14px; border-radius:20px; font-size:0.82rem; font-weight:600; cursor:pointer; transition:all 0.15s ease;">
      {{ e.label }}
      <span
        [style.background]="estadoSeleccionado === e.id ? 'rgba(255,255,255,0.25)' : '#f3f4f6'"
        [style.color]="estadoSeleccionado === e.id ? 'white' : '#6b7280'"
        style="min-width:20px; text-align:center; padding:1px 7px; border-radius:10px; font-size:0.72rem; font-weight:700;">
        {{ count(e.id) }}
      </span>
    </button>

    <button mat-icon-button color="primary" title="Recargar" (click)="load()" style="margin-left:auto;">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <div class="loading" *ngIf="loading" style="display:flex; justify-content:center; padding:32px;">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <app-list-payer
    *ngIf="!loading"
    [setPagadores]="pagadores"
    (reloadAccountList)="load()"
  ></app-list-payer>

  <p class="empty" *ngIf="!loading && pagadores.length === 0"
    style="text-align:center; color:#9ca3af; padding:24px;">
    No hay pagadores en este estado.
  </p>
</div>
